import dispatcher from './AppDispatcher';

import AppActionTypes from './AppActionTypes';

export default {
    header: (data, callback) => {
        // console.log(`== ACTION »`, AppActionTypes.HEADER, data);
        dispatcher.dispatch({
            type: AppActionTypes.HEADER,
            data: data,
            callback: callback
        })
    },
    navigation: (data, callback) => {
        // console.log(`== ACTION »`, AppActionTypes.NAVIGATION, data);
        dispatcher.dispatch({
            type: AppActionTypes.NAVIGATION,
            data: data,
            callback: callback
        })
    },
    animation: (data, callback) => {
        // console.log(`== ACTION »`, AppActionTypes.ANIMATION, data);
        dispatcher.dispatch({
            type: AppActionTypes.ANIMATION,
            data: data,
            callback: callback
        })
    },
    speaker: (data, callback) => {
        // console.log(`== ACTION »`, AppActionTypes.SPEAKER, data);
        dispatcher.dispatch({
            type: AppActionTypes.SPEAKER,
            data: data,
            callback: callback
        })
    },
    modal: (data, callback) => {
        // console.log(`== ACTION »`, AppActionTypes.MODAL, data);
        dispatcher.dispatch({
            type: AppActionTypes.MODAL,
            data: data,
            callback: callback
        })
    },
}